<template>
  <div>
    <el-radio-group :class="{'paymentType-group': true, 'is-vertical': direction === 'vertical'}" v-model="paymentType">
      <div v-if="direction === 'horizontal'">
        <span class="paymentType-item" :class="{'no-label': displayStyle === 2 && hasIcon(item.key)}" v-for="(item, index) in GLOBAL.enumPaymentType.getOptionsForCheckpay(excepts, withOther)" :key="index">
          <el-radio name="paymentType" :disabled="readonly" :label="item.value">
            <span>{{item.desc}}</span>
          </el-radio>
          <el-link v-if="hasIcon(item.key)" v-show="[0, 2].contains(displayStyle)" :underline="false" :disabled="readonly" @click="onPaymentTypeIconClick(item.value)">
            <el-tooltip effect="light" placement="top" :content="item.desc" :manual="displayStyle !== 2 || !hasIcon(item.key)">
              <i class="icon">
                <img :src="paymentImgList[item.key]" />
              </i>
            </el-tooltip>
          </el-link>
        </span>
      </div>
      <div v-else>
        <table>
          <tr class="paymentType-item" :class="{'no-label': displayStyle === 2 && hasIcon(item.key)}" v-for="(item, index) in GLOBAL.enumPaymentType.getOptionsForCheckpay(excepts, withOther)" :key="index">
            <td>
              <el-radio name="paymentType" :disabled="readonly" :label="item.value">
                <span>{{item.desc}}</span>
              </el-radio>
            </td>
            <td>
              <el-link v-if="hasIcon(item.key)" v-show="[0, 2].contains(displayStyle)" :underline="false" :disabled="readonly" @click="onPaymentTypeIconClick(item.value)">
                <el-tooltip effect="light" placement="top" :content="item.desc" :manual="displayStyle !== 2">
                  <i class="icon">
                    <img :src="paymentImgList[item.key]" />
                  </i>
                </el-tooltip>
              </el-link>
            </td>
          </tr>
        </table>
      </div>
    </el-radio-group>
  </div>
</template>

<script>
import { getPaymentImgList } from "@/config/mUtils.js";

export default {
  name: "paymentSelector",
  components: {},
  props: {
    direction: {
      type: String,
      default: "horizontal",
      validator: (value) => ["horizontal", "vertical"].contains(value),
    },
    //0-显示全部，1-显示文本，2-显示图标
    displayStyle: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1, 2].contains(value),
    },
    readonly: {
      type: Boolean,
      default: false
    },
    excepts: {
      type: [Array, Number],
      default: null
    },
    withOther: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number,
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      paymentType: null,
    };
  },
  beforeCreate() {
    this.paymentImgList = getPaymentImgList();
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.paymentType = this.value;
    },
    hasIcon(key) {
      return Object.keys(this.paymentImgList).contains(key);
    },
    onPaymentTypeIconClick(typeId) {
      this.paymentType = typeId;
    },
  },
  watch: {
    value() {
      this.init();
    },
    paymentType(newVal) {
      this.$emit("change", newVal);
    }
  },
};
</script>

<style lang="scss" scoped>
.paymentType-group {
  line-height: 48px;
  margin-right: 20px;

  &.is-vertical {
    margin-right: 0;
    margin-bottom: 20px;

    .paymentType-item {
      margin-right: 0;
      padding: 10px 0;
    }
  }

  .paymentType-item {
    margin-right: 10px;

    .icon {
      padding: 0;
      width: 32px;
      height: 32px;
      cursor: pointer;

      img {
        vertical-align: middle;
        text-align: center;
        width: 32px;
        height: 32px;
      }
    }

    &.no-label {
      .el-radio {
        /deep/ .el-radio__label {
          display: none;
        }
      }
    }
  }

  .el-radio {
    vertical-align: middle;
    text-align: center;
    margin: 0;
    padding: 0 8px;
  }

  .el-link {
    &.is-disabled {
      opacity: 0.5;

      .icon {
        cursor: not-allowed;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payApi/paymentSelector.vue